export const MESSAGE_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.MessageTemplateInterface.MessageTemplate';
